import { definePreset } from '@primeng/themes';
import Material from '@primeng/themes/material';

const LifsMaterial = definePreset(Material, {
    semantic: {
        primary: {
            50: '#f4f8fb',
            100: '#e7f1f7',
            200: '#cae0ed',
            300: '#9bc6de',
            400: '#65a8cb',
            500: '#3d84a8',
            600: '#317298',
            700: '#285c7c',
            800: '#254e67',
            900: '#234357',
            950: '#172b3a'
        },
        // primary: {
        //     50: '{sky.50}',
        //     100: '{sky.100}',
        //     200: '{sky.200}',
        //     300: '{sky.300}',
        //     400: '{sky.400}',
        //     500: '{sky.500}',
        //     600: '{sky.600}',
        //     700: '{sky.700}',
        //     800: '{sky.800}',
        //     900: '{sky.900}',
        //     950: '{sky.950}'
        // },
        colorScheme: {
            light: {
                surface: {
                    0: '#ffffff',
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    0: '#ffffff',
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    },
    components: {
        progressspinner: {
            colorScheme: {
                light: {
                    root: {
                        colorOne: '{primary.200}',
                        colorTwo: '{primary.400}',
                        colorThree: '{primary.600}',
                        colorFour: '{primary.800}'
                    }
                },
                dark: {
                    root: {
                        colorOne: '{primary.50}',
                        colorTwo: '{primary.200}',
                        colorThree: '{primary.400}',
                        colorFour: '{primary.600}'
                    }
                }
            }
        }
    }
});

export default LifsMaterial;